var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllBiller(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "#8B9095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4701",
    "data-name": "Group 4701",
    transform: "translate(-272 -173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2744",
    "data-name": "Rectangle 2744",
    transform: "translate(272 173)",
    fill: "#fff",
    stroke: "#8B9095",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 17,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 16,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4680",
    "data-name": "Group 4680",
    transform: "translate(274.893 177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2745",
    "data-name": "Rectangle 2745",
    width: 4,
    height: 1,
    transform: "translate(0.107 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2746",
    "data-name": "Rectangle 2746",
    width: 9,
    height: 1,
    transform: "translate(0.107 3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2747",
    "data-name": "Rectangle 2747",
    width: 9,
    height: 1,
    transform: "translate(0.107 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2748",
    "data-name": "Rectangle 2748",
    width: 9,
    height: 1,
    transform: "translate(0.107 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllBiller);
export default __webpack_public_path__ + "static/media/all-biller.816c91cf.svg";
export { ForwardRef as ReactComponent };